import React, { useState } from "react";
import {
  Dialog,
  IconButton,
  Typography,
  withStyles
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { LoadingIndicator } from "../../../../Component";
import { SearchRecords } from "../../..";
import styles from "./styles";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../Component/CustomButton";

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const CreateRelationDialog = (props) => {
  const {
    classes,
    isDialogOpen,
    onSubmit,
    onClose,
    user,
    hasPermission,
  } = props;
  const { t } = useTranslation();
  const [isLoading, setLoading] = useState(false);

  const renderLoadingIndicator = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <LoadingIndicator />
      </div>
    );
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const onRecordSelect = async (record, source) => {
    setLoading(true);
    await onSubmit(record, source);
    setLoading(false);
  };

  const searchRecordActions = [
    {
      iconClass: "far fa-plus",
      position: "row",
      tooltip: t("labels.record.search.actions.addRelatedEntity"),
      callBack: onRecordSelect,
    },
  ]

  return (
    <Dialog
      disableBackdropClick
      onClose={handleClose}
      aria-labelledby="add-document-modal"
      open={isDialogOpen}
      fullWidth={true}
      maxWidth="xl"
      scroll={'paper'}
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle id="add-document-modal" onClose={handleClose}>
        <Typography className={classes.panelTitle}>
          {t("labels.record.relatedEntities.newRelation")}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {isLoading ? (
          renderLoadingIndicator()
        ) : (
            <SearchRecords
              recordActions={searchRecordActions}
              dropTopMargin={true}
              onNewRecordSubmit={(r) => onRecordSelect(r, "NEW")}
              user={user}
              hasPermission={hasPermission}
              hideCheckTypeSelection={true}
            />
          )}
      </DialogContent>

      <DialogActions>
        <CustomButton 
          variant="secondary" 
          isDisabled={isLoading}
          onClick={handleClose}
        >
          {t("labels.common.cancel")}
        </CustomButton>
      </DialogActions>
    </Dialog>
  )
}

export default withStyles(styles, { withTheme: true })(CreateRelationDialog);